export default __webpack_public_path__ + "assets/audio/1-4303190_clip.mp3";